
<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import { setToken } from "@/libs/utils";
export default {
  name: "App",
  metaInfo: {
    title: "okex量化交易",
    titleTemplate: "%s |野莓网络科技 ",
    meta: [
      { charset: "utf-8" },
      { name: "description", content: "foo" },
      { keyword: "量化交易" },
    ],
  },
  // mounted(){
  //   /**
  //    *判断浏览器窗口是刷新或者关闭操作
  //    * 无论任何浏览器不管是刷新或者是关闭都会执行下面两个方法 onbiforeunload  onunload
  //    * 根据时间差来实现
  //    * 在点击刷新或者关闭时开始计时记录下这一刻的时间戳
  //    * 因为刷新和关闭 在执行onunload方法时的时间不一样，一般情况下经过测试
  //    * 关闭时时间差不大于3毫秒
  //    * 刷新时即使只有一个简单的helloworld页面都不少于10毫秒
  //    * 而一般网站网页内容更多，时间差达到了100多毫秒
  //    *
  //    *
  //    * 下面方法的缺点是不管你开了多少窗口，都会在关闭一个窗口时清空所有localStorage缓存
  //    * 造成所有页面都需要重新登录，其实这也是针对项目而言的，目前本项目就不认为这是缺点
  //    * 而能更好的保护用户信息
  //    **/
  //   // let beginTime = 0;//开始时间
  //   // let differTime = 0;//时间差
  //   // window.onunload = function (){
  //   //   differTime = new Date().getTime() - beginTime;
  //   //   if(differTime <= 5) setToken('');
  //   // };
  //   // window.onbeforeunload = function (){
  //   //   beginTime = new Date().getTime();
  //   // };
  //
  //   /*区分关闭和刷新，关闭退出登录 start*/
  //   window.onload = function(){
  //     if(!window.sessionStorage["tempFlag"]){
  //       setToken('');
  //       this.$router.push({
  //         path:'/'
  //       })
  //     }else{
  //       window.sessionStorage.removeItem("tempFlag");
  //     }
  //   }
  //   window.onunload = function (){
  //     window.sessionStorage["tempFlag"] = true;
  //   }
  //   window.onbeforeunload = function (){
  //     window.sessionStorage["tempFlag"] = true;
  //   }
  // }
};
</script>
<style lang="less">
@import "../static/theme/color.less";
</style>
<style lang="less">
.mycolor_modal .ivu-table .ivu-table-row:hover  td{
  color: #000;
  background-image: linear-gradient(-90deg, #bbeaec,#96ecd7,#bbeaec) !important;
}
.mycolor_modal .ivu-table-body .ivu-table-tbody .ivu-table-row:hover .ivu-table-column-center{
  background-image: linear-gradient(-90deg, #bbeaec,#96ecd7,#bbeaec) !important;
}

.size {
  width: 100%;
  height: 100%;
}
html,
body {
  .size;
  margin: 0;
  padding: 0;
}
#app {
  width: 100%;
  height: 100%;
}
.trade_main_modal {
  .ivu-modal-body {
    padding: 0;
  }
}

.mycolor_modal {
  height: 0 !important;
  //  .ivu-table:hover{
  //    background-color: aqua;
  //     background-image:''
  //  }
.imdexs {
  background-color: #9EDE5B;
  border: 2px solid #9EDE5B;
display: inline-block;
width: 20px;
height: 20px;
border-radius: 50%;
line-height: 20px;
  color: #fff;
position: absolute;
left: -50px;
}


.imdexss {
  background-color: #EF5568;
  border: 2px solid #EF5568;
display: inline-block;
width: 20px;
height: 20px;
border-radius: 50%;
line-height: 20px;
  color: #fff;
  position: absolute;
left: -50px;
}
.ivu-table td.index_color span{
  position: absolute;
  z-index: 99999999;
  // color: #ffffff;
  top: 13px;
  right: 35px;
}
.imdexsss{

display: inline-block;
color: #f0e58e;
text-shadow: 0 4px 3px #797777;
font-size: 22px;

left: -0px;
top: 5px;
  position: absolute;
}
  .ivu-table  td{
    position: relative;
    border-collapse: collapse;
  }
 
  .ivu-table table{
    border-collapse: collapse;
  }
  .ivu-table td ,.ivu-table tr,.ivu-table th{
        border: 1px solid rgb(189, 184, 184);
        
  }
  .ivu-table .demo-table-buy-row td {
    color: #747373;
    // background-image: linear-gradient(-90deg, #ffffff 0%, #d6facd 100%);
    background-color: rgba(214, 250, 205, .5);
  

  }
  .ivu-table .demo-table-sell-row td {
    color: #747373;
    // background-image: linear-gradient(-90deg, #ffffff 0%, #fae1e1 100%);
    background-color: rgba(250, 225, 225, .5);
  }
  .ivu-table .demo-table-runover-row td {
    color: #747373;
    background-color: #e1e1e1 !important;
    // background-image: linear-gradient(-90deg, #ffffff 100%, #ddd4d4 100%);
  }
  .ivu-table .demo-table-buy-row-opacity td{
    color: #747373;//afafaf 原字体颜色
    // background-image: linear-gradient(-90deg,  #ffffff 0% ,#e8ffe3 100%);
       background-color: rgba(232, 255, 227, .5);
  }
  .ivu-table .demo-table-buy-all-opacity td{
    color: #747373;
    // background-image: linear-gradient(-90deg,  #ffffff 0% ,#fff0f0 100%)
     background-color: rgba(255, 240, 240, .5);
  }
   .ivu-table .demo-table-sell-row-error td{
    color: red;
    font-weight: 800;
    font-size: 20px;
  }
  .conditionul li{
    // background-color: #96ecd7;
    // border: 1.5px dashed #8C8C8C;
    box-shadow: 1px 3px 5px 1px #8c8c8c;
    margin: 3px 10px;
  }
  
}

.Autoexecute_styles .Unittoshow{
     border: 1.5px dashed rgb(45, 140, 240);
    margin: 10px 10px 0 10px;
}
.ivu-poptip-popper {
  .api {
    .ivu-table td {
      background-color: transparent;
    }
    .ivu-table .demo-table-buy-row {
      color: #afafaf;
      // background-image: linear-gradient(-90deg, #ffffff 0%, #d6facd 100%);
       background-color: rgba(214, 250, 205, .5);
    }
    .ivu-table .demo-table-sell-row {
      color: #afafaf;
      // background-image: linear-gradient(-90deg, #ffffff 0%, #fff0f0 100%);
      background-color: rgba(255, 240, 240, .5);
    }
      .demo-table-sell-row-error td{
    color: red;
  }
    
  }
}
// .demo-table-sell-row td{
//   color: #b41818;
//     // background-color: #e1e1e1;
//   background-image: linear-gradient( -90deg , #FFFFFF 0%, #D6FACD 100%);
// }
.active{
  margin: 5px;
  padding: 2px;
  display: table;
  height: 28px;
  line-height: 20px;
  border: 1px solid #dcdee2;
  border-radius: 3px;
}
.conditionok{
   background-color: rgb(230, 230, 230);
   display: inline-block;
   margin: 2px;
  color:rgb(172, 172, 172);
  font-size: 10px;
  padding: 2px 10px;
  border: 1px solid #dfdfdf;
}
.conditionoknot{
    // background-color: rgb(230, 230, 230);
     display: inline-block;
     margin: 2px;
    color:#000;
    font-size: 10px;
    padding: 2px 10px;
    border: 1px solid #dfdfdf;
}
.actionok{
  background-color: #9AD1C7;
  display: inline-block;
  margin: 2px;
color:#E6F3F1;
font-size: 10px;
padding: 2px 10px;
border: 1px solid #dfdfdf;
}
.logical{
  border: none !important;
}
.actionnot{
  background-color: #2ABDA1;
  display: inline-block;
  margin: 2px;
color:#ffffff;
font-size: 10px;
padding: 2px 10px;
border: 1px solid #dfdfdf;
}
.ivu-spin-fullscreen {
    z-index: 9999999 !important;
}
.qd .ivu-modal-header{
  background-image: linear-gradient(to right,#4386FF, #FEFFFF) !important;
  font-weight: 800 !important;
  color: #ffffff !important;
}
.qd .ivu-input{
  border-radius: 0 !important;
}
.qd .ivu-select-selection ,.qd div{
  border-radius: 0 !important;
}
.ivu-table-stripe-even td{
    background-color: #F0F5FF!important;
  }
  /*奇数行*/
  .ivu-table-stripe-odd td{
    background-color: #ffffff!important;
  }
  .mycolor_modal .ivu-modal-header{
  background-image: linear-gradient(to right,#4386FF, #FEFFFF) !important;
}
.light{
   th,td{
    background-color: #fff !important;
   
   }
  
   .plTableBox .el-table--scrollable-x .el-table__body-wrapper{
    background-color: #fff !important;
    
   }
   .plTableBox .el-table tr:hover td{
    background-color: #4b6cf1 !important;
   }
}
</style>



// WEBPACK FOOTER //
// src/App.vue